import React from 'react';
import {Navigate} from "react-router-dom";
import {TOKEN_STORAGE_KEY} from "../../services/firebase_services";

export const isAuthenticated = () => {
    return Boolean(localStorage.getItem(TOKEN_STORAGE_KEY));
};

const ProtectedRoute = ({children}: { children: React.JSX.Element }) => {
    if (!isAuthenticated()) {
        return <Navigate to="/auth"/>;
    }
    return children;
};

export default ProtectedRoute;
